import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function returnCurLang(obj, id) {
  if (_typeof(obj) === "object") {
    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (key === 'title') {
        if (Array.isArray(obj[key])) {
          obj[key] = obj[key].map(function (item) {
            return item[id] || '';
          });
          continue;
        }
        if (_typeof(obj[key]) === "object") {
          obj[key] = obj[key][id] || '';
          continue;
        }
      }
      if (Array.isArray(obj[key])) {
        try {
          obj[key] = obj[key].map(function (item) {
            return returnCurLang(item, id);
          });
        } catch (e) {
          console.log(e, obj[key]);
        }
        continue;
      }
      if (_typeof(obj[key]) === 'object') {
        obj[key] = returnCurLang(obj[key], id);
      }
    }
  }
  return obj;
}
export function initLang(prop, title) {
  var langList = localStorage.langList;
  if (langList) {
    langList = JSON.parse(langList);
    langList.forEach(function (item) {
      prop[item.langId] = title;
    });
  }
}